import { Component, EventEmitter } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    templateUrl: "edit-refund-modal.component.html",
    standalone: false
})
export class EditRefundModalComponent {
    title: string = "Edit Refund";
    submitted: boolean = false;
    submitEvent: EventEmitter<{ amount: number, reason: string }> = new EventEmitter();

    id: number;
    accountCode: string;
    description: string;
    amount: number;
    reason: string;
    maxRefundable: number;

    form: UntypedFormGroup;
    modalRef: BsModalRef;

    constructor(
        private bsModalRef: BsModalRef,
        private formBuilder: UntypedFormBuilder
    ) {
        this.modalRef = bsModalRef;
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            amount: [this.amount, [Validators.required, Validators.min(0.01), Validators.max(this.maxRefundable)]],
            reason: [this.reason, [Validators.required]],
        });
    }

    get f(): { [key: string]: AbstractControl; } {
        return this.form.controls;
    }

    onSubmit() {
        this.submitted = true;

        if (this.form.invalid) {
            return;
        }

        this.modalRef.hide();

        this.submitEvent.emit({
            amount: this.form.get("amount").value,
            reason: this.form.get("reason").value,
        });
    }
}
